import { render, staticRenderFns } from "./index.vue?vue&type=template&id=fb6805ac"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fb6805ac')) {
      api.createRecord('fb6805ac', component.options)
    } else {
      api.reload('fb6805ac', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=fb6805ac", function () {
      api.rerender('fb6805ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/purchase/entry/result/index.vue"
export default component.exports